import React, { useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from 'react-redux';
import { setDefaultEntity, setDefaultFrequency, setDefaultGstin, setDefaultSelectPeriod, setViewData } from "containers/ITC-04/ViewData/action";
import { profileInfo, storeSelectedGstinITC04 } from "containers/ITC-04/action";
import { setPeriodStore, storeSelectedEntity, storeSelectedGstin } from "containers/gstr6/action";
import { setPrepareData } from "containers/ITC-04/PrepareReturn/action";
import { setAnalyticsData } from "containers/ITC-04/Analytics/action";
function ProtectedRoute({ component: Component, ...restOfProps }) {
  const isAuthenticated = localStorage.getItem("loginDetails");
  //----------------------------------
  const dispatch = useDispatch();
  const location = useLocation();


  useEffect(() => {
    // Check if the current path is not '/itc04/' and set Redux state to null
    if (!location.pathname.includes('/itc04/')) {
      dispatch(setViewData([]));
      dispatch(setAnalyticsData([]))
      dispatch(setPrepareData([]));
      dispatch(setDefaultEntity(""))
      dispatch(setDefaultGstin(""))
      dispatch(setDefaultFrequency(""))
      dispatch(setDefaultSelectPeriod({}))
      dispatch(storeSelectedGstinITC04([]))
      dispatch(profileInfo([]))
    }
    if(!location.pathname.includes('/gstr6/')){
      dispatch(storeSelectedEntity(""));
      dispatch(storeSelectedGstin(""));
      dispatch(setPeriodStore(""));
    }
  }, [dispatch, location.pathname]);


  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
}

export default ProtectedRoute;